if (!customElements.get('variant-products-toggle')) {
  customElements.define(
    'variant-products-toggle',
    class VariantProductsToggle extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.button?.addEventListener('click', this.toggle.bind(this));
      }

      toggle() {
        const list = this.closest('.product-variant-products');
        if (!list) return;
        const expanded = list.classList.toggle('product-variant-products--expanded');
        this.button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (expanded) {
          list.querySelector('.product-variant-products__item--overflow a')?.focus();
        }
      }
    }
  );
}
